<template>
  <div class="construction-body-div col-12 banCopy">
    <ul class="construction-list list-unstyled col-8">
      <li
        class="construction-list-item mouseLink"
        v-for="item in listArr"
        :key="item"
        @click="gotoEssay(item.id,item.title, item.content, item.author)"
      >
        <div class="construction-item-box">
          <div class="construction-img-box">
            <img class="construction-img" :src="item.img_url" />
          </div>
          <div class="construction-item-title-box">
            <h5 class="construction-item-title">{{ item.title }}</h5>
            <h6 class="construction-item-timeText">
              {{ item.create_time }}
            </h6>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listArr: [],
    };
  },
  mounted() {
    this.Post();
  },
  methods: {
    gotoEssay(id,title, content,author) {
      this.$router.push({
        name: "essay",
        query: {
          id: id,
          // title: title,
          // content: content,
          // author:author,
          type: "construction",
        },
      });
    },
    Post() {
      var url = "http://demoapi.hkjt.cn/pages/corporateCulture.php?type=1";

      this.axios
        .get(url)
        .then((res) => {
          this.listArr = res.data;
        })
        .catch((e) => {
          if (e.response) {
            //请求已发出，服务器返回状态码不是2xx。
            console.info(e.response.data);
            console.info(e.response.status);
            console.info(e.response.headers);
          } else if (e.request) {
            // 请求已发出，但没有收到响应
            // e.request 在浏览器里是一个XMLHttpRequest实例，
            // 在node中是一个http.ClientRequest实例
            console.info(e.request);
          } else {
            //发送请求时异常，捕捉到错误
            console.info("error", e.message);
          }
          console.info(e.config);
        });
    },
  },
};
</script>

<style scoped>
.construction-item-timeText {
  position: absolute;
  top: 3.2rem;
  left: 1.05rem;
}
</style>